'use client';

import React from 'react';
import { Icons } from '@shared/ui';

export enum HEADER_CART_ICON_KEY {
    STYLE_1 = 'style_1',
    STYLE_2 = 'style_2',
    STYLE_3 = 'style_3',
    STYLE_4 = 'style_4',
}

export const headerCartIconMap = {
    [HEADER_CART_ICON_KEY.STYLE_1]: (
        <Icons.csr.ShoppingCart width="24px" height="24px" weight="bold" />
    ),
    [HEADER_CART_ICON_KEY.STYLE_2]: (
        <Icons.csr.ShoppingCartSimple width="24px" height="24px" weight="bold" />
    ),
    [HEADER_CART_ICON_KEY.STYLE_3]: (
        <Icons.csr.ShoppingCart width="24px" height="24px" weight="fill" />
    ),
    [HEADER_CART_ICON_KEY.STYLE_4]: (
        <Icons.csr.ShoppingCartSimple width="24px" height="24px" weight="fill" />
    ),
};
